import { CustomCardView } from "./CustomCardView";
import { Box, Divider, IconButton, Stack } from "@mui/material";
import { CustomTextView } from "./CustomTextView";
import { ReactElement } from "react";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../data/colors/Colors";

interface props {
  title: string;
  startIcon?: ReactElement;
  editIcon?: ReactElement;
  onEditButtonClicked?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  height?: number;
  minHeight?: number;
  layout: ReactElement;
  hasDivider?: boolean;
  background?: string;
  hasIconButtonAsParent?: boolean;
}

export const CustomTitledView: React.FC<props> = ({
  title,
  startIcon,
  editIcon,
  onEditButtonClicked,
  height,
  layout,
  minHeight,
  hasDivider = true,
  background = "transparent",
  hasIconButtonAsParent = true,
}: props) => {
  return (
    <CustomCardView
      padding={0}
      height={height}
      minHeight={minHeight}
      background={background}
      children={
        <Stack
          spacing={0}
          height={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            p={2}
          >
            <Stack spacing={1} alignItems={"center"} direction={"row"}>
              {editIcon && startIcon}
              <CustomTextView
                text={title}
                fontWeight="600"
                variant="h6"
              />
            </Stack>

            {editIcon && (
              <Box>
                {hasIconButtonAsParent ? (
                  <IconButton onClick={onEditButtonClicked}>
                    {editIcon}
                  </IconButton>
                ) : (
                  <>{editIcon}</>
                )}
              </Box>
            )}
          </Stack>
          {hasDivider && <Divider sx={{ background: COLOR_LIGHT_GRAY }} />}
          {layout}
        </Stack>
      }
    />
  );
};
